export default "__VITE_ASSET__ByGV19VO__"